import React from 'react'
import { matchPath, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { useContextHook } from '../../store/context'
import { setCurrentMachine } from '../../store/actions'
import { Machine } from '../../types/machine'
import NavButton from './navMenuButton'
import MachineLoader from './machineLoader'

const MachineSelector = (): JSX.Element => {
  const location = useLocation()
  const navigate = useNavigate()
  const { dispatch, state } = useContextHook()
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = (): void => {
    setAnchorEl(null)
  }

  const onSelectMachine = (machine: Machine): void => {
    if (machine.slug !== state.currentMachine?.slug) {
      dispatch(setCurrentMachine(null))
    }
    navigate(`/machine/${machine.slug}${getUrlSuffix()}`)
    handleCloseMenu()
  }

  const getUrlSuffix = (): string => {
    const logsMatch = matchPath('/machine/:machineId/logs/*', location.pathname)
    const profileMatch = matchPath('/machine/:machineId/profiles/*', location.pathname)
    const scheduleMatch = matchPath('/machine/:machineId/schedules/*', location.pathname)
    if (logsMatch) {
      return '/logs/'
    }
    if (profileMatch) {
      return '/profiles/'
    }
    if (scheduleMatch) {
      return '/schedules/'
    }
    return '/live'
  }

  return (
    <>
      <NavButton onClick={handleOpenMenu}>{state.currentMachine?.name || t('navmenu.machines')}</NavButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        {state.machines.map((machine) => {
          const batch_number =
            machine.prod_batch && machine.prod_number ? `p${machine.prod_batch}_${machine.prod_number} ` : ''
          return (
            <MenuItem key={machine.id} onClick={() => onSelectMachine(machine)}>
              {`${batch_number} ${machine.name}`}
            </MenuItem>
          )
        })}
        {anchorEl && <MachineLoader />}
      </Menu>
    </>
  )
}

export default MachineSelector
